"use client";

import { useState } from "react";

export function FolderOpenPage({ folderName, onBack, onAddFile }) {
  const [viewMode, setViewMode] = useState("board");
  const [activeSection, setActiveSection] = useState("documents");

  // Sample files data to display in the grid
  const files = Array.from({ length: 10 }, (_, i) => ({
    id: i + 1,
    name: "Data Privacy & Security Policies",
    owner: "Catherine Jacobs",
    date: "26/03/2024",
  }));

  return (
    <div className="p-6">
      <div className="flex items-center gap-4 mb-6">
        <div className="flex gap-2">
          <button
            onClick={() => setActiveSection("documents")}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
              activeSection === "documents"
                ? "bg-white border border-gray-300 text-gray-900"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            Documents
          </button>
          <button
            onClick={() => setActiveSection("assets")}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
              activeSection === "assets"
                ? "bg-white border border-gray-300 text-gray-900"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            Assets
          </button>
        </div>
      </div>

      <div className="mb-6">
        <h2 className="text-lg font-medium text-gray-900">Folder name</h2>
      </div>

      <div className="mb-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-6">
            <h3 className="text-lg font-medium text-gray-900">All Files</h3>
            <div className="flex items-center gap-2">
              <button
                onClick={() => setViewMode("board")}
                className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  viewMode === "board"
                    ? "bg-blue-50 text-blue-600"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                <span className="text-lg">⊞</span>
                Board View
              </button>
              <button
                onClick={() => setViewMode("list")}
                className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  viewMode === "list"
                    ? "bg-blue-50 text-blue-600"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                <span className="text-lg">☰</span>
                List View
              </button>
            </div>
          </div>
          <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm font-medium">
            Add new
          </button>
        </div>

        {viewMode === "board" ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {files.map((file) => (
              <div
                key={file.id}
                className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
              >
                <div className="flex items-start justify-between mb-3">
                  <div className="w-8 h-8 bg-blue-500 rounded flex items-center justify-center">
                    <span className="text-white text-sm">📄</span>
                  </div>
                  <button className="text-gray-400 hover:text-gray-600">
                    <span className="text-lg">⋯</span>
                  </button>
                </div>
                <h4 className="font-medium text-gray-900 text-sm mb-2 line-clamp-2">
                  {file.name}
                </h4>
                <div className="text-xs text-gray-500">
                  <p className="mb-1">{file.owner}</p>
                  <p>{file.date}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Name
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Owner
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Date
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {files.map((file) => (
                  <tr
                    key={file.id}
                    className="hover:bg-gray-50"
                  >
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-6 h-6 bg-blue-500 rounded flex items-center justify-center">
                          <span className="text-white text-xs">📄</span>
                        </div>
                        <span className="text-sm font-medium text-gray-900">
                          {file.name}
                        </span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">
                      {file.owner}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">
                      {file.date}
                    </td>
                    <td className="px-4 py-3">
                      <button className="text-gray-400 hover:text-gray-600">
                        <span className="text-lg">⋯</span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="mt-8">
        <button
          onClick={onBack}
          className="text-blue-600 hover:text-blue-800 text-sm font-medium"
        >
          ← Back to Files
        </button>
      </div>
    </div>
  );
}
